import { createSlice } from "@reduxjs/toolkit";

const educationalBackground = {
  university: "",
  department: "",
  graduationYear: ""
};

const initialTeacher = {
  tcKimlikNo: "",
  name: "",
  surname: "",    
  birthPlace: "",
  birthDate: "",
  homePhone: "",
  mobilePhone1: "",
  mobilePhone2: "",
  email1: "",
  email2: "",
  city: "",
  county: "",
  address: "",
  serviceYear: 0,
  workingYearInTheSchool: 0,
  yearOfSeniority: 0,
  branches: [],
  sexes: [],
  maritalStatuses: [],    
  graduationTypes: [],
  contract: {
    term: 0,
    insuranceStartDate: "",
    insuranceEndDate: "",
    contractStartDate: "",
    contractEndDate: "",
    formalContractStartDate: "",
    formalContractEndDate: "",
    salary: "",
    formalSalary: "",
    bank: "",
    accountNo: "",
    iban: "",
    insurances: []
  },
  graduate: educationalBackground,
  postGraduate: educationalBackground,
  doctorate: educationalBackground,
  partner: {
    tcKimlikNo: "",
    name: "",
    surname: "",
    occupation: "",
    occupationCategories: []
  }
};

const initialTeachersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  branches: [],
  teacher: initialTeacher
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const teacherSlice = createSlice({
  name: "teachers",
  initialState: initialTeachersState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getTeachers
    teachersFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getBranches
    branchesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.branches = entities;
    },
    //getTeacher
    teacherFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.teacher = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanTeachersState
    teachersStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.teacher = initialTeacher;
    }
  }
});